// Mutations
export const SET_DASHBOARD = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dashboard.data = payload
    state.dashboard.lastUpdate = new Date()
  }
}
export const ADD_DASHBOARD = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.dashboard.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.dashboard.data.push(data)
      }
    })
  }
}
export const SET_DASHBOARD_LOADING = (state, payload) => {
  state.dashboard.loading = payload
}

export const SET_PERMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.permissions.data = payload
    state.permissions.lastUpdate = new Date()
  }
}
export const ADD_PERMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.permissions.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.permissions.data.push(data)
      }
    })
  }
}
export const SET_PERMISSIONS_LOADING = (state, payload) => {
  state.permissions.loading = payload
}

export const SET_UPDATE_DASH = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.updateDash.data = payload
    state.updateDash.lastUpdate = new Date()
  }
}
export const ADD_UPDATE_DASH = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.updateDash.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.updateDash.data.push(data)
      }
    })
  }
}
export const SET_UPDATE_DASH_LOADING = (state, payload) => {
  state.updateDash.loading = payload
}

export const SET_EMBED = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.embed.data = payload
    state.embed.lastUpdate = new Date()
  }
}
export const ADD_EMBED = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.embed.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.embed.data.push(data)
      }
    })
  }
}
export const SET_EMBED_LOADING = (state, payload) => {
  state.embed.loading = payload
}

export const SET_CACHE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.cache.data = payload
    state.cache.lastUpdate = new Date()
  }
}
export const ADD_CACHE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.cache.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.cache.data.push(data)
      }
    })
  }
}
export const SET_CACHE_LOADING = (state, payload) => {
  state.cache.loading = payload
}

export const SET_STATUS_CACHE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.statusCache.data = payload
    state.statusCache.lastUpdate = new Date()
  }
}
